import {
  Box,
  Paper,
  Stack,
  Typography,
} from "@mui/material"


function SectionCard({
  title,
  subtitle,
  actions,
  children,
  noPadding = false,
  sx = {},
}) {
  return (
    <Paper
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 3,
        overflow: "hidden",
        boxShadow: "0 6px 18px rgba(15,23,42,0.035)",
        ...sx,
      }}
    >
      {(title || subtitle || actions) ? (
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          justifyContent="space-between"
          alignItems={{
            xs: "stretch",
            sm: "center",
          }}
          spacing={1}
          sx={{
            px: {
              xs: 1.5,
              sm: 2,
            },
            py: 1.5,
            borderBottom: "1px solid",
            borderColor: "divider",
            bgcolor: "#fff",
          }}
        >
          <Box
            sx={{
              minWidth: 0,
            }}
          >
            {title ? (
              <Typography
                variant="h6"
                sx={{
                  fontSize: 17,
                  fontWeight: 900,
                }}
              >
                {title}
              </Typography>
            ) : null}

            {subtitle ? (
              <Typography
                color="text.secondary"
                sx={{
                  mt: 0.25,
                  fontSize: 12.5,
                }}
              >
                {subtitle}
              </Typography>
            ) : null}
          </Box>

          {actions ? (
            <Box
              sx={{
                flexShrink: 0,
              }}
            >
              {actions}
            </Box>
          ) : null}
        </Stack>
      ) : null}

      <Box
        sx={{
          p: noPadding
            ? 0
            : {
                xs: 1.5,
                sm: 2,
              },
        }}
      >
        {children}
      </Box>
    </Paper>
  )
}


export default SectionCard
